export default {
  editTitle: 'Editar Plan',
  newTitle: 'Nuevo Plan',
  save: 'Guardar',
  create: 'Crear',
  name: 'Nombre',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  weekly: 'Semanal',
  weeklyDisabledForTemplate: 'La frecuencia está fijada a la granularidad de los datos del template.',
  weekDefinition: 'Definición de Semana',
  weekDefinitionInfo1: 'Las semanas comienzan los lunes.',
  weekDefinitionInfo2: 'Las semanas se representan por la fecha de su último día (domingo).',
  weekDefinitionInfo3: 'Incluso si solo un día de una semana determinada está comprendido entre la Fecha de Inicio y la Fecha de Fin, esa semana se considerará en el plan.',
  weekDefinitionInfo4: 'Por eso, cuando tu Fecha de Fin cae a mitad de semana, la última columna lleva una fecha posterior: es el domingo en que termina la semana a la que pertenece tu Fecha de Fin.',
  ok: 'Ok',
  nameRequired: 'El nombre es obligatorio',
  dateRequired: 'La fecha es obligatoria',
  mustBeAfterStartDate: 'Debe ser posterior a la fecha de inicio'
}
